// Environment configuration module to centralize import.meta.env usage
// This makes it easier to mock in tests

// Check if we're in a test environment and handle import.meta safely
const isTest = typeof process !== 'undefined' && process.env.NODE_ENV === 'test';

const getEnvVar = (key: string, defaultValue?: string) => {
  if (isTest) {
    // In test environment, try to get from process.env first, then from mocked import.meta
    return process.env[key] || 
           (globalThis as any)?.import?.meta?.env?.[key] || 
           (global as any)?.import?.meta?.env?.[key] || 
           defaultValue;
  }
  // In non-test environment, use import.meta.env
  return (import.meta as any).env[key] || defaultValue;
};

export const env = {
  DEV: isTest ? true : getEnvVar('DEV', true),
  MODE: getEnvVar('MODE', isTest ? 'test' : 'development'),
  DEBUG: getEnvVar('DEBUG', 'false').toLowerCase() === 'true',
  VITE_DEBUG: getEnvVar('VITE_DEBUG', 'true'),
  VITE_APP_NAME: getEnvVar('VITE_APP_NAME', 'Tequisa Employee Tracker'),
  VITE_DIRECTUS_URL: getEnvVar('VITE_DIRECTUS_URL', 'https://directus-aok8wgokg0w4g4wkos4g0ok0.217.15.164.63.sslip.io'),
  VITE_API_URL: getEnvVar('VITE_API_URL', 'http://localhost:4000/api'),
} as const;

export default env;